export const getSiteLabel = (sites, siteInternalId) => {
  const matchingSites = sites.filter((s) => s.id == siteInternalId);
  if (matchingSites.length > 0) {
    return matchingSites[0].externalId ? matchingSites[0].externalId : matchingSites[0]?.name;
  }
  return '';
};
